<template>
    <div class="cover-panel-wrapper">
        <div class="no-cover-panel" v-show="!hasCover" @click="upLoadImage" v-if="!ishorizontal">
            <span class="item-cover-icon">
                <Icon :width="22" :height="20" :bgPosition="noCoverIcon.position" class="no-cover-icon" />
            </span>
            <p>{{ noCoverIcon.label }}</p>
        </div>
        <div class="no-cover-panel-h" v-show="!hasCover" @click="upLoadImage" v-else>
            <Icon :bgPosition="noCoverIcon.position" class="no-cover-icon-h" />
            <p>{{ noCoverIcon.label }}</p>
        </div>
        <div class="has-cover-panel" v-show="hasCover">
            <div class="cover-image-panel" v-if="hasCover">
                <div class="cover-image-alt" v-if="!hasRealCover">{{ coverTip }}</div>
                <img :src="imageUrl" class="cover-image" v-show="hasRealCover" />
            </div>
            <div class="cover-operators">
                <div @click="imageClick">
                    <div v-for="(item, idx) in operates" :key="idx">
                        <span class="cover-operator-icon" @click.stop="itemClick(item)">
                            <Icon
                                :width="16"
                                :height="18"
                                :bgPosition="!hasRealCover && item.noCoverPosition ? item.noCoverPosition : item.position"
                            />
                        </span>
                        <p>{{ !hasRealCover && item.noCoverName ? item.noCoverName : item.name }}</p>
                    </div>
                </div>
            </div>
            <Icon
                :width="22"
                :height="20"
                v-show="!viewIcon.isShowIcon"
                :bgPosition="viewIcon.position"
                class="cover-view-icon"
                @iconClick="viewClick"
            />
        </div>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "CoverPanel",
    props: ["noCoverIcon", "operateIcons", "imageUrl", "viewIcon", "ishorizontal"],
    components: {
        Icon
    },
    data() {
        return {
            coverTip: this.$t("zhiji.answer.uploadCover")
        };
    },
    computed: {
        hasCover() {
            return !!this.imageUrl;
        },
        operates() {
            return this.operateIcons || [];
        },
        hasRealCover() {
            return this.imageUrl && this.imageUrl != "none";
        }
    },
    methods: {
        itemClick(item) {
            this.$emit("operatorSelect", item.type);
        },
        upLoadImage() {
            this.$emit("uploadCover");
        },
        viewClick() {
            this.$emit("viewClick");
        },
        imageClick() {
            this.$emit("imageClick");
        }
    }
};
</script>

<style lang="scss" scoped>
.cover-panel-wrapper {
    height: 150px;
    background: #fafbfd;
    border-radius: 4px;

    .no-cover-panel {
        cursor: pointer;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-radius: 4px;

        &:hover {
            color: #2ec2ff;

            .no-cover-icon {
                background-position-y: -74px !important;
            }
        }
    }
    .no-cover-panel-h {
        cursor: pointer;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .no-cover-icon-h {
            margin-right: 5px;
        }

        &:hover {
            color: #2ec2ff;

            .no-cover-icon-h {
                background-position-y: -22px !important;
            }
        }
    }

    .has-cover-panel {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background: #fafbfd;
        border-radius: 4px 4px 0px 0px;

        .cover-image-panel {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border-radius: 4px 4px 0px 0px;

            .cover-image {
                max-width: 100%;
                max-height: 100%;
                border-radius: 4px 4px 0px 0px;
            }
        }

        .cover-image-alt {
            color: #ec9c20;
            font-weight: bold;
        }

        .cover-operators {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 100%;
            height: 100%;
            background: rgba(65, 71, 94, 0.6);
            border-radius: 4px 4px 0 0;
            box-sizing: border-box;
            z-index: 1;

            & > div {
                display: inline-flex;
                align-items: center;
                text-align: center;
                justify-content: space-around;
                width: 100%;
                height: 100%;
                color: #fff;
            }
        }

        .cover-operator-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background: #ffffff;
            box-shadow: 0 2px 6px 0 rgba(46, 98, 151, 0.2);
            border-radius: 50%;
            margin-bottom: 5px;
            cursor: pointer;
        }

        &:hover .cover-operators {
            display: block;
        }
    }

    .cover-view-icon {
        position: absolute;
        bottom: 5px;
        right: 5px;
        z-index: 2;
    }
}
</style>
